(function () {
  if (window.__bpAttributionHelperInstalled) return;
  window.__bpAttributionHelperInstalled = true;

  var SESSION_KEY = 'bp_sid';
  var FIRST_KEY = 'bp_first_touch';
  var LAST_KEY = 'bp_last_touch';
  var MAX_CARRY_LENGTH = 8192;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  var SENSITIVE = /^(?:e|bp_attr|bp_sid)$|(?:email|e-mail|pin|password|token|secret|auth|checkout|discount|code)/i;
  var EMAIL = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
  var PHONE = /^\+?[\d\s().-]{10,24}$/;
  var memory = { sessionId: null, firstTouch: null, lastTouch: null };
  var pageSnapshot = null;

  function read(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) {}
  }

  function sessionId() {
    var stored = read(SESSION_KEY);
    if (stored && /^[A-Za-z0-9._:-]{8,100}$/.test(stored)) {
      memory.sessionId = stored;
      return stored;
    }
    if (memory.sessionId) return memory.sessionId;
    try {
      memory.sessionId = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);
    } catch (error) {
      memory.sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
    }
    write(SESSION_KEY, memory.sessionId);
    return memory.sessionId;
  }

  function safeUrl(value) {
    if (typeof value !== 'string' || !value || value.length > 12000) return null;
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
      url.username = '';
      url.password = '';
      Array.from(url.searchParams.entries()).forEach(function (entry) {
        if (SENSITIVE.test(entry[0]) || EMAIL.test(entry[1]) || PHONE.test(entry[1])) {
          url.searchParams.delete(entry[0]);
        }
      });
      var split = url.hash.indexOf('?');
      if (split >= 0) {
        var hash = new URLSearchParams(url.hash.slice(split + 1));
        Array.from(hash.entries()).forEach(function (entry) {
          if (SENSITIVE.test(entry[0]) || EMAIL.test(entry[1]) || PHONE.test(entry[1])) {
            hash.delete(entry[0]);
          }
        });
        url.hash = url.hash.slice(0, split) + '?' + hash.toString();
      }
      return url.href.slice(0, 1600);
    } catch (error) {
      return null;
    }
  }

  function safeValue(value, limit) {
    if (typeof value !== 'string' || !value.trim() || value.length > limit ||
        EMAIL.test(value) || PHONE.test(value)) return null;
    return value.trim();
  }

  function decode(value) {
    if (!value || value.length > MAX_CARRY_LENGTH || !/^[A-Za-z0-9_-]+$/.test(value)) return null;
    try {
      var base64 = value.replace(/-/g, '+').replace(/_/g, '/');
      var binary = window.atob(base64 + '='.repeat((4 - (base64.length % 4)) % 4));
      var bytes = Uint8Array.from(binary, function (character) { return character.charCodeAt(0); });
      var text = new TextDecoder().decode(bytes);
      var payload = JSON.parse(text);
      if (!payload || !/^[A-Za-z0-9._:-]{8,100}$/.test(payload.sessionId || '')) return null;
      var first = sanitizeTouch(payload.firstTouch);
      var last = payload.lastTouch === null ? null : sanitizeTouch(payload.lastTouch);
      if (!first || (payload.lastTouch !== null && !last)) return null;
      return { sessionId: payload.sessionId, firstTouch: first, lastTouch: last };
    } catch (error) {
      return null;
    }
  }

  function sanitizeTouch(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    var date = typeof value.captured_at === 'string' ? Date.parse(value.captured_at) : NaN;
    if (!Number.isFinite(date)) return null;
    var result = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (key) {
      var limit = key === 'fbclid' ? 512 : key === 'utm_campaign' || key === 'utm_content' || key === 'utm_term' ? 256 : 200;
      result[key] = safeValue(value[key], limit);
    });
    result.landing_url = safeUrl(value.landing_url);
    result.referrer = safeUrl(value.referrer);
    result.captured_at = new Date(date).toISOString();
    return result;
  }

  function urlParams() {
    var params = new URLSearchParams(window.location.search);
    var question = window.location.hash.indexOf('?');
    if (question >= 0) {
      var hashParams = new URLSearchParams(window.location.hash.slice(question + 1));
      hashParams.forEach(function (value, key) {
        if (!params.has(key)) params.set(key, value);
      });
    }
    return params;
  }

  function currentTouch() {
    var params = urlParams();
    var touch = {};
    KEYS.forEach(function (key) {
      var limit = key === 'fbclid' ? 512 : key === 'utm_campaign' || key === 'utm_content' || key === 'utm_term' ? 256 : 200;
      touch[key] = safeValue(params.get(key), limit);
    });
    touch.landing_url = safeUrl(window.location.href);
    touch.referrer = safeUrl(document.referrer);
    touch.captured_at = new Date().toISOString();
    return touch;
  }

  function validTagged(touch) {
    return KEYS.some(function (key) { return typeof touch[key] === 'string' && touch[key].length > 0; });
  }

  function storedTouch(key) {
    try { return sanitizeTouch(JSON.parse(read(key) || 'null')); } catch (error) { return null; }
  }

  function visit() {
    var params = urlParams();
    var carry = decode(params.get('bp_attr'));
    if (carry) {
      var targetFirst = storedTouch(FIRST_KEY);
      var targetSession = read(SESSION_KEY);
      var targetSessionIsValid = targetSession && /^[A-Za-z0-9._:-]{8,100}$/.test(targetSession);
      // First touch and its local session form one origin-scoped pair. Since
      // browser storage is isolated across origins, a URL carry cannot prove
      // that an existing destination pair is stale; preserve any valid pair.
      var previousSession = read(SESSION_KEY);
      if (!targetFirst) {
        memory.sessionId = carry.sessionId;
        memory.firstTouch = carry.firstTouch;
        write(FIRST_KEY, JSON.stringify(carry.firstTouch));
        write(SESSION_KEY, carry.sessionId);
      } else if (!targetSessionIsValid) {
        // A pre-existing first touch cannot be paired reliably with the
        // carried origin ID, so create a destination ID without replacing it.
        memory.sessionId = sessionId();
        write(SESSION_KEY, memory.sessionId);
      } else {
        memory.sessionId = previousSession;
      }
      if (!storedTouch(LAST_KEY) && carry.lastTouch) {
        memory.lastTouch = carry.lastTouch;
        write(LAST_KEY, JSON.stringify(carry.lastTouch));
      }
    }

    var current = currentTouch();
    var first = storedTouch(FIRST_KEY) || memory.firstTouch || current;
    memory.firstTouch = first;
    write(FIRST_KEY, JSON.stringify(first));

    var last = storedTouch(LAST_KEY) || memory.lastTouch;
    if (validTagged(current)) {
      last = current;
      memory.lastTouch = current;
      write(LAST_KEY, JSON.stringify(current));
    } else if (last) {
      memory.lastTouch = last;
    }
    return { sessionId: sessionId(), firstTouch: first, lastTouch: last || null };
  }

  pageSnapshot = visit();
  window.__bpReadAttribution = function () {
    return pageSnapshot;
  };
  if (!window.__bpAttributionLandingTracked) {
    window.__bpAttributionLandingTracked = true;
    try {
      var configured = window.__BLUEPRINT_CONFIG && window.__BLUEPRINT_CONFIG.apiBaseUrl;
      var base = typeof configured === 'string' && configured.trim()
        ? configured.replace(/\/$/, '')
        : 'https://theta-foundry.replit.app';
      fetch(base + '/api/analytics/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: 'attribution_landing',
          sessionId: pageSnapshot.sessionId,
          properties: { page: window.location.pathname, firstTouch: pageSnapshot.firstTouch }
        }),
        keepalive: true
      }).catch(function () {});
    } catch (error) {}
  }
})();